/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreatePassengerRequest } from '../models/create-passenger-request';
import { GenericResponse } from '../models/generic-response';
import { GetPassengerResponse } from '../models/get-passenger-response';
import { PassengerResponse } from '../models/passenger-response';
import { UpdatePassengerRequest } from '../models/update-passenger-request';

/**
 * passenger apis
 */
@Injectable({ providedIn: 'root' })
export class PassengerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllPassenger()` */
  static readonly GetAllPassengerPath = '/api/v1/passengers';

  /**
   * Get list of passenger.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllPassenger()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPassenger$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - idNumber
       * - idSubType
       * - issuedCountry
       * - lastName
       * - name
       * - countryOfBirth
       * - travelType
       * - gender
       * - travelType
       * - passengerType
       *   - type
       * - idType
       *   - type
       * - nationality
       *   - name
       *   - code
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetPassengerResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      PassengerService.GetAllPassengerPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetPassengerResponse>;
        })
      );
  }

  /**
   * Get list of passenger.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllPassenger$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPassenger(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - idNumber
       * - idSubType
       * - issuedCountry
       * - lastName
       * - name
       * - countryOfBirth
       * - travelType
       * - gender
       * - travelType
       * - passengerType
       *   - type
       * - idType
       *   - type
       * - nationality
       *   - name
       *   - code
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<GetPassengerResponse> {
    return this.getAllPassenger$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<GetPassengerResponse>): GetPassengerResponse =>
          r.body
      )
    );
  }

  /** Path part for operation `createPassenger()` */
  static readonly CreatePassengerPath = '/api/v1/passengers';

  /**
   * Create new passenger.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPassenger()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPassenger$Response(
    params: {
      body: CreatePassengerRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PassengerResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      PassengerService.CreatePassengerPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<PassengerResponse>;
        })
      );
  }

  /**
   * Create new passenger.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPassenger$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPassenger(
    params: {
      body: CreatePassengerRequest;
    },
    context?: HttpContext
  ): Observable<PassengerResponse> {
    return this.createPassenger$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<PassengerResponse>): PassengerResponse => r.body
      )
    );
  }

  /** Path part for operation `getPassengerDetailsById()` */
  static readonly GetPassengerDetailsByIdPath = '/api/v1/passengers/{id}';

  /**
   * Get passenger details by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPassengerDetailsById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPassengerDetailsById$Response(
    params: {
      /**
       * The passenger's id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PassengerResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      PassengerService.GetPassengerDetailsByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<PassengerResponse>;
        })
      );
  }

  /**
   * Get passenger details by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPassengerDetailsById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPassengerDetailsById(
    params: {
      /**
       * The passenger's id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<PassengerResponse> {
    return this.getPassengerDetailsById$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<PassengerResponse>): PassengerResponse => r.body
      )
    );
  }

  /** Path part for operation `deletePassenger()` */
  static readonly DeletePassengerPath = '/api/v1/passengers/{id}';

  /**
   * Delete passenger by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePassenger()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePassenger$Response(
    params: {
      /**
       * The passenger's id that needs to be deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      PassengerService.DeletePassengerPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Delete passenger by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePassenger$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePassenger(
    params: {
      /**
       * The passenger's id that needs to be deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.deletePassenger$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updatePassenger()` */
  static readonly UpdatePassengerPath = '/api/v1/passengers/{id}';

  /**
   * Update passenger by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePassenger()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePassenger$Response(
    params: {
      /**
       * The passenger's id that needs to be updated
       */
      id: number;
      body: UpdatePassengerRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<PassengerResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      PassengerService.UpdatePassengerPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<PassengerResponse>;
        })
      );
  }

  /**
   * Update passenger by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePassenger$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePassenger(
    params: {
      /**
       * The passenger's id that needs to be updated
       */
      id: number;
      body: UpdatePassengerRequest;
    },
    context?: HttpContext
  ): Observable<PassengerResponse> {
    return this.updatePassenger$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<PassengerResponse>): PassengerResponse => r.body
      )
    );
  }
}
